// ===========================================================================
// A Lumi Link pasted into a chat on Lumi.
//
// The Lumi Link is for bringing somebody from OUTSIDE Lumi: a friend opens it
// and comes straight to you instead of the queue. People kept pasting it into
// the chat they were in, to the person already talking to them, where it did
// nothing for anybody and was reported to moderation as a link (the operator,
// 2026-10-08). So a message carrying one is not sent: the person is told, in
// the chat, what the link is for. No imports, so a test can load it without a
// browser. ASCII only.
// ===========================================================================

/** What the chat says instead of sending it, in the page's language (pass i18n's t). */
export function lumiLinkHeld(t = (x) => x) {
  return t('Not sent. That is a Lumi Link, for bringing a friend from outside Lumi: send it to them in a text or a DM. The person here is already talking to you.');
}

const LINK_RE = /(?:https?:\/\/)?(?:www\.)?([a-z0-9.-]+\.[a-z]{2,}(?::\d+)?)\/i\/[a-z0-9]{4,}/gi;

/**
 * Whether the text carries a Lumi Link: /i/CODE on lumichat.io or on the site
 * the page is served from. Anybody's, not only this person's: none of them
 * belongs in a chat here.
 * @param {string} text
 * @param {string} [host] the page's own host; lumichat.io always counts
 */
export function holdsALumiLink(text, host = typeof location !== 'undefined' ? location.host : '') {
  const hosts = new Set(['lumichat.io', String(host || '').toLowerCase()].filter(Boolean));
  for (const m of String(text || '').matchAll(LINK_RE)) {
    if (hosts.has(m[1].toLowerCase())) return true;
  }
  return false;
}

export default { holdsALumiLink, lumiLinkHeld };
